export default __webpack_public_path__ + "static/media/card3.7d1d3b2b.png";